export default __webpack_public_path__ + "static/media/33-CoC.ffe2b906.jpg";